// Excel de las estadísticas: una hoja por bloque + el detalle por intake.
// Usa los mismos datos que se ven en pantalla (misma respuesta de la API,
// con los mismos filtros), así que respeta filtros y permisos.
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const hojaDe = (filas, anchos) => {
    const ws = XLSX.utils.json_to_sheet(filas.length ? filas : [{ '': 'Sin datos con estos filtros' }]);
    if (anchos) ws['!cols'] = anchos.map(w => ({ wch: w }));
    return ws;
};
const dist = (bloque, nombre, extra) => (bloque.items || []).map(it => Object.assign({ [nombre]: it.t, Intakes: it.n, '%': it.pct }, extra ? extra(it) : {}));

export function exportarExcel(d, filtrosTexto) {
    const wb = XLSX.utils.book_new();
    const add = (nombre, filas, anchos) => XLSX.utils.book_append_sheet(wb, hojaDe(filas, anchos), nombre.slice(0, 31));
    const r = d.resumen, p = r.presupuesto;

    add('Resumen', [
        { Dato: 'Período', Valor: d.periodo.texto },
        { Dato: 'Zona horaria', Valor: d.zona.nombre },
        { Dato: 'Filtros', Valor: filtrosTexto || 'Ninguno' },
        { Dato: 'Generado', Valor: d.generado },
        { Dato: 'Se cuenta', Valor: d.contar === 'personas' ? 'Personas únicas (sin duplicados)' : 'Todos los intakes (con duplicados)' },
        { Dato: d.contar === 'personas' ? 'Total de personas' : 'Total de intakes', Valor: r.intakes.total },
        ...(d.duplicados ? [
            { Dato: 'Intakes del período (con duplicados)', Valor: d.duplicados.intakes },
            { Dato: 'Personas únicas', Valor: d.duplicados.personas },
            { Dato: 'Intakes duplicados', Valor: d.duplicados.repetidos },
            { Dato: 'Personas con más de un intake', Valor: d.duplicados.personas_con_varios },
        ] : []),
        { Dato: 'Período anterior (' + (d.periodo.anterior ? d.periodo.anterior.texto : '—') + ')', Valor: r.intakes.comparacion ? r.intakes.comparacion.anterior : '' },
        { Dato: 'Variación vs. período anterior (%)', Valor: r.intakes.comparacion && r.intakes.comparacion.pct !== null ? r.intakes.comparacion.pct : '' },
        { Dato: 'Presupuesto mediano (USD/mes)', Valor: p.mediana },
        { Dato: 'Presupuesto: mitad central (P25–P75)', Valor: p.n ? `${p.p25}–${p.p75}` : '' },
        { Dato: 'Presupuesto promedio (USD/mes)', Valor: p.promedio },
        { Dato: 'Intakes con presupuesto válido', Valor: p.n },
        { Dato: 'Presupuestos fuera de rango', Valor: p.fuera_rango },
        { Dato: 'Lead score promedio', Valor: r.lead_score.promedio },
        { Dato: 'Lead score promedio sin ErasmusPlay', Valor: r.lead_score.promedio_sin_erasmus },
        { Dato: 'Shortlists creadas', Valor: r.shortlists.total },
        { Dato: 'Intakes con al menos una shortlist', Valor: r.shortlists.intakes_con },
        { Dato: 'Intakes con reserva confirmada', Valor: r.reservas.intakes },
        { Dato: 'Reservas confirmadas', Valor: r.reservas.reservas },
    ], [44, 40]);
    add('Intakes por mes', d.por_mes.items.map(m => ({ Mes: `${m.t} ${m.anio}`, Intakes: m.n })), [14, 10]);
    if (d.crecimiento) {
        const v = (m, k) => (m.vs && m.vs[k] && m.vs[k].pct !== null ? m.vs[k].pct : '');
        add('Crecimiento mes a mes', d.crecimiento.items.map(m => ({
            Mes: `${m.mes} ${m.anio}${m.parcial ? ` (1 al ${d.crecimiento.hoy})` : ''}`,
            Intakes: m.intakes, 'Intakes % vs. mes anterior': v(m, 'intakes'),
            Shortlists: m.shortlists, 'Shortlists % vs. mes anterior': v(m, 'shortlists'),
            'Reservas confirmadas': m.reservas, 'Reservas % vs. mes anterior': v(m, 'reservas'),
            'Presupuesto mediana USD': m.presupuesto === null ? '' : m.presupuesto, 'Presupuesto % vs. mes anterior': v(m, 'presupuesto'),
        })), [22, 9, 12, 11, 12, 11, 12, 13, 13]);
    }
    add('Llegadas por mes', d.llegadas.items.map(m => ({ 'Mes de llegada': `${m.t} ${m.anio}`, 'Intakes activos': m.n })), [16, 14]);
    add('Duración estancia', dist(d.estancia, 'Duración'), [20, 10, 8]);
    add('Embudo', d.embudo.map(e => ({ Etapa: e.t, Intakes: e.n, '% del total': e.pct, Definición: e.d })), [26, 10, 12, 60]);
    add('Brokers', d.brokers.map(b => ({
        Broker: b.t, Intakes: b.intakes, 'Presupuesto mediano USD': b.presupuesto, 'Rango P25–P75': b.presupuesto_rango ? b.presupuesto_rango.join('–') : '',
        Shortlists: b.shortlists, 'Intakes con shortlist': b.intakes_con_shortlist, 'Intakes con reserva': b.reservados, 'Ciudad principal': b.ciudad, 'Intakes en esa ciudad': b.ciudad_n,
    })), [24, 9, 22, 14, 11, 20, 18, 20, 18]);
    add('Tipo de alojamiento', dist(d.tipo_alojamiento, 'Tipo', it => ({ Qué_es: it.d })), [30, 9, 7, 60]);
    add('Edad', dist(d.edad, 'Edad'), [14, 9, 7]);
    add('Personas', dist(d.personas, 'Personas'), [14, 9, 7]);
    add('Ciudades', dist(d.ciudades, 'Ciudad', it => ({ País: it.pais || '', Verificada: it.verificada ? 'Sí' : 'No' })), [24, 9, 7, 14, 10]);
    add('Nacionalidades', dist(d.nacionalidades, 'Nacionalidad', it => ({ Mercado: it.mercado })), [24, 9, 7, 16]);
    add('Mercados', dist(d.mercados, 'Mercado'), [16, 9, 7]);
    if (d.destinos) add('Destino por región', dist(d.destinos, 'Región de destino'), [18, 9, 7]);
    add('Origen', dist(d.canales, 'Origen'), [32, 9, 7]);
    add('Universidad origen', dist(d.uni_origen, 'Universidad', it => ({ Verificada: it.verificada ? 'Sí' : 'No' })), [44, 9, 7, 10]);
    add('Universidad destino', dist(d.uni_destino, 'Universidad', it => ({ Verificada: it.verificada ? 'Sí' : 'No' })), [44, 9, 7, 10]);
    add('Partners', d.partners.items.map(x => ({
        Partner: x.t, Tipo: { partner: 'Partner', equipo: 'Equipo H&F', otro: 'Texto libre' }[x.tipo] || x.tipo, Intakes: x.intakes, '%': x.pct, Shortlists: x.shortlists,
        'Intakes con reserva': x.reservados, 'Códigos de entrada': x.codigos.join(', '), 'Cómo lo escribieron': x.escrito.join(' | '),
    })), [32, 12, 9, 7, 11, 18, 26, 50]);
    add('Horas', d.horas.items.map(h => ({ Hora: h.t, Intakes: h.n, '%': h.pct })), [8, 9, 7]);
    add('Días', d.dias.items.map(h => ({ Día: h.t, Intakes: h.n, '%': h.pct })), [12, 9, 7]);
    add('Alojamientos', d.alojamientos.items.map(a => ({
        ID: a.id, Nombre: a.nombre || '', País: a.pais || '', Ciudad: a.ciudad || '', Tipo: a.tipo || '', Categoría: a.categoria || '', Capacidad: a.capacidad || '',
        'Precio USD/mes': a.precio_usd || '', 'Precio publicado': a.precio_original ? `${a.precio_original[0]} ${a.precio_original[1]} (${a.precio_original[2]})` : '',
        Recomendaciones: a.recomendaciones, 'Intakes distintos': a.intakes,
    })), [8, 50, 12, 18, 12, 14, 10, 14, 22, 15, 15]);
    const R = d.reservas;
    add('Reservas', R.lista.map(x => ({
        Reserva: x.id, Fecha: x.fecha, Intake: x.intake, Estudiante: x.intake_nombre, Broker: x.broker, 'Presupuesto USD': x.presupuesto || '',
        Alojamiento: x.alojamiento, 'Nombre alojamiento': x.aloj_nombre, Tipo: x.tipo, Categoría: x.categoria, Ciudad: x.ciudad || '', País: x.pais || '',
        Capacidad: x.capacidad || '', 'Precio USD/mes': x.precio_usd || '',
    })), [9, 11, 8, 26, 20, 15, 11, 50, 11, 13, 18, 12, 10, 14]);
    const perfil = [];
    [['Ciudad', 'ciudad'], ['Presupuesto', 'presupuesto'], ['Mercado', 'mercado'], ['Partner', 'partner']].forEach(([n, k]) => (R.perfil[k] || []).forEach(s => perfil.push({ Segmento: n, Valor: s.t, Intakes: s.intakes, 'Con reserva': s.reservados, '% que reserva': s.pct })));
    add('Quién reserva', perfil, [14, 30, 9, 12, 14]);
    add('Calidad de datos', d.calidad.items.map(c => ({ Indicador: c.t, Intakes: c.n, '%': c.pct, Detalle: c.d || '' })), [44, 9, 7, 70]);
    add('Definiciones', d.definiciones.map(x => ({ Concepto: x.t, Definición: x.d })), [24, 110]);
    if (d.detalle) add('Intakes (detalle)', d.detalle, [7, 16, 24, 28, 16, 18, 12, 24, 16, 22, 22, 16, 14, 22, 14, 30, 30, 12, 14, 28, 9, 6, 11, 11, 11, 10, 10, 10]);

    const f = new Date(), dia = `${f.getFullYear()}-${String(f.getMonth() + 1).padStart(2, '0')}-${String(f.getDate()).padStart(2, '0')}`;
    const nombre = `Estadisticas_intakes_${dia}.xlsx`;
    const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), nombre);
    return nombre;
}
